import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {SIDEBAR_NAVIGATION_BUTTONS} from "../../../../../constants";
import workspace from "../../../../canvas/core/workspace";
import {FormattedMessage} from "react-intl";
import {activateBumpoutTool} from "../../../../canvas/core/controls/canvasBridge";

const SqftNavBumpouts = (props) => {
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_BUTTONS.bumpout;
  // const buttonRefs = useRef({});

  const handleAddBumpoutClick = function () {
    workspace.setAllowBumpoutEdges(true);
    workspace.setAllowLineHighlight(true);
    //Bumpout.addBumpout_onClick();
    activateBumpoutTool();
    setTimeout(function () {
      workspace.setAllowLineHighlight(false)
    }, 1000)
  };

  const handleResetBumpoutClick = function () {
    workspace.removeAllBumpouts();
  };

  return (
    <div className={"bumpout side single" + (expanded ? " expanded" : "")} data-content="bumpout" data-action="open-side">
      <div className="shapes-list sidebar-buttons sidebar-buttons-column">
        {expanded ? (
          <Fragment>
            <button className="animated fadeInUp button button--inner shapes-icon button--add-bumpout"
                    data-menu="add-bumpout"
                    // ref={(el) => buttonRefs.current[0] = el}
                    onClick={() => handleAddBumpoutClick()}
                    data-set="add-bumpout">
              <span className="button-text" data-text="sqft.navigation.submenu.addBumpout">
                <FormattedMessage id={"sqft.navigation.submenu.addBumpout"}/>
              </span>
            </button>
            <button className="animated fadeInUp button button--inner shapes-icon button--reset-bumpout"
                    data-menu="reset-bumpout"
                    onClick={() => handleResetBumpoutClick()}
                    // ref={(el) => buttonRefs.current[1] = el}
                    data-set="reset-bumpout">
              <span className="button-text" data-text="sqft.navigation.submenu.resetBumpout">
                <FormattedMessage id={"sqft.navigation.submenu.resetBumpout"}/>
              </span>
            </button>
          </Fragment>
        ) : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  return {
    menuOpened
  };
};

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavBumpouts);
